import React, { useEffect, useState } from 'react'
import { CForm, CFormInput, CButton, CFormTextarea, CTooltip, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CFormLabel, CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem, CNav, CNavItem, CNavLink, CTabContent, CTabPane, CCardBody, CSpinner } from '@coreui/react'
import Graytextarea from '../../components/Graytextarea'
import getPatientPersonalHistory from '../../services/general/getPatientHistory.api'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import { useIndexedDB } from '../../context/IndexedContext'

const ProviderHistoryAddModalTest = ({ AddHistoryToggle, loggedUserProvider, setAddHistoryToggle, patientID, noteStructureRef, saveTreatsShell, setHistories, getPatientHistory, setPatientDBData }) => {
  const [textInput, setTextInput] = useState({
    pmhx: '',
    pshx: '',
    fh: '',
    sh: '',
  })

  const { getTestOfflineData, getProviderDetails, saveTestOfflineData } = useIndexedDB()
  const getFormattedDate = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    return `${mm}.${dd}.${yyyy}`
  }
  const [currentDate, setCurrentDate] = useState('')
  useEffect(() => {
    setCurrentDate(getFormattedDate())
  }, [])

  const historyTypeMapping = {
    pmhx: 'MedicalHistory',
    pshx: 'SurgicalHistory',
    fh: 'FamilyHistory',
    sh: 'SocialHistory',
  }
  const [activeTab, setActiveTab] = useState('pmhx')
  const [loading, setLoading] = useState(false)

  const handleInputChange = (event, type) => {
    // setTextInput(event.target.value);
    setTextInput((prev) => ({
      ...prev,
      [type]: event.target.value,
    }))
  }

  const [loadings, setLoadings] = useState(false)
  // const addHistoryNote = async (type) => {
  //     if (!textInput[activeTab].trim()) {
  //         toast.error("Please fill the history", toastConfig)
  //     }
  //     setLoadings(true)
  //     try {
  //         if (!textInput[activeTab]) {
  //             return;
  //         }
  //         const historyType = historyTypeMapping[activeTab];
  //         const newNote = { Date: currentDate };
  //         newNote[historyTypeMapping[activeTab]] = textInput[activeTab];
  //         setHistories(prevHistories => ({
  //             ...prevHistories,
  //             [type]: [newNote, ...prevHistories[type]|| '']
  //         }));

  //         await getPatientPersonalHistory('INSERT', patientID, historyType, '', textInput[activeTab])
  //         let allData = await getPatientPersonalHistory('GET', patientID, historyType, '');
  //         let formattedData = JSON.parse(allData?.d);
  //         formattedData = formattedData?.Data
  //         if (formattedData.length > 0) {
  //             const latestHistoryId = formattedData[formattedData.length - 1]?.Id;
  //             noteStructureRef.current = {
  //                 ...noteStructureRef.current,
  //                 metadata: {
  //                     ...noteStructureRef.current.metadata,
  //                     [historyType]: latestHistoryId || ""
  //                 },
  //             };

  //             // setEditableIdExistIntoNotes((p) => ({
  //             //     ...p,
  //             //     [historyType]: latestHistoryId
  //             // }))
  //             await saveTreatsShell(false);
  //             await getPatientHistory()
  //         }
  //         setTextInput({
  //             pmhx: '',
  //             pshx: '',
  //             fh: '',
  //             sh: ''
  //         });

  //             toast.success("History added successfully", toastConfig)
  //         // toast.success("History added successfully",)

  //     } catch (error) {
  //         console.error("error while adding history",error)
  //     }
  //     finally {
  //         setLoadings(false);
  //         setAddHistoryToggle(false)
  //     }
  // };

  const addHistoriesInLocal = async (newHistories) => {
    const data = await getTestOfflineData()
    const loggedUser = await getProviderDetails()
    const loggedUserID = loggedUser?.ID
    const userData = { ...(data[loggedUserID] || {}) }
    const patientData = { ...(userData[patientID] || {}) }
    const existingHistories = patientData.patientHistories || []
    const newlyAddedData = patientData.newlyAddedData || []
    const newlyAddedHistories = patientData?.newlyAddedData?.patientHistories || {}

    const updatedHistories = {
      ...existingHistories,
      ...Object.keys(newHistories).reduce((acc, key) => {
        acc[key] = newHistories[key]
        return acc
      }, {}),
    }

    const updatedPatientData = {
      ...patientData,
      patientHistories: updatedHistories,
      newlyAddedData: { ...newlyAddedData, patientHistories: newHistories },
    }

    const updatedUserData = {
      ...userData,
      [patientID]: updatedPatientData,
    }

    const updatedData = {
      ...data,
      [loggedUserID]: updatedUserData,
    }
    await saveTestOfflineData(updatedData)
    await setPatientDBData(updatedPatientData)
  }

  const handleAddHistoryIdToOfflineData = async (historyType, value) => {
    let dataOffline = await getTestOfflineData()
    if (dataOffline) {
      dataOffline = {
        ...dataOffline,
        [loggedUserProvider?.ID]: {
          ...dataOffline[loggedUserProvider?.ID],
          [patientID]: {
            ...dataOffline[loggedUserProvider?.ID][patientID],
            currentNote: {
              ...dataOffline[loggedUserProvider?.ID][patientID].currentNote,
              data: {
                ...dataOffline[loggedUserProvider?.ID][patientID].currentNote.data,
                metadata: {
                  ...dataOffline[loggedUserProvider?.ID][patientID].currentNote.data?.metadata,
                  [historyType]: value,
                },
              },
            },
          },
        },
      }
    }
    await saveTestOfflineData(dataOffline)
  }
  const addHistoryNote = async () => {
    const historyTypeMapping = {
      pmhx: 'MedicalHistory',
      pshx: 'SurgicalHistory',
      fh: 'FamilyHistory',
      sh: 'SocialHistory',
    }

    const generateTempId = (() => {
      let counter = 0
      return () => {
        counter += 1
        return Number(`${Date.now()}${counter}`)
      }
    })()

    setLoadings(true)
    try {
      const newHistories = {}

      for (const key of Object.keys(textInput)) {
        if (!textInput[key]?.trim()) continue

        const historyType = historyTypeMapping[key]
        const tempId = generateTempId()
        const newNote = {
          Id: tempId, // ✅ store numeric temp ID
          Date: currentDate,
          [historyType]: textInput[key],
        }

        newHistories[key] = [newNote, ...(Array.isArray(newHistories[key]) ? newHistories[key] : [])]
      }

      // await getPatientPersonalHistory('INSERT', patientID, historyType, '', textInput[activeTab])
      await addHistoriesInLocal(newHistories)
      setHistories((prev) => ({
        ...prev,
        ...newHistories,
      }))

      noteStructureRef.current = {
        ...noteStructureRef.current,
        metadata: {
          ...noteStructureRef.current.metadata,
          ...Object.keys(newHistories).reduce((acc, key) => {
            const historyType = historyTypeMapping[key]
            const tempId = newHistories[key][0]?.Id || ''
            handleAddHistoryIdToOfflineData(historyType, tempId)
            acc[historyType] = tempId
            return acc
          }, {}),
        },
      }

      setTextInput({
        pmhx: '',
        pshx: '',
        fh: '',
        sh: '',
      })

      toast.success('All histories added successfully', toastConfig)
    } catch (error) {
      console.error('Error while adding histories', error)
      toast.error('Failed to add histories', toastConfig)
    } finally {
      setLoadings(false)
      setAddHistoryToggle(false)
    }
  }

  const userData = JSON.parse(localStorage.getItem('user'))
  const role = userData?.Role
  const handleDiagnosis = () => {}
  return (
    <>
      <CModal alignment="center" visible={AddHistoryToggle} onClose={() => setAddHistoryToggle(false)} size="lg">
        {/* Header */}
        <CModalHeader
          style={{
            backgroundColor: '#282828',

            justifyContent: 'center',
            borderRadius: '10px 10px 0 0 ',
          }}
        >
          <CModalTitle
            style={{
              color: 'white',
              fontWeight: '600',
              textAlign: 'center',
              width: '100%',
            }}
          >
            Add Historyss
          </CModalTitle>
        </CModalHeader>

        {/* Body */}
        <CModalBody style={{ backgroundColor: '#282828', color: '#fff', padding: '10px 50px' }}>
          {/* Tabs */}
          {/* <CNav variant="tabs" className="mb-3 justify-content-between " style={{borderBottom:'none'}}>
              {[
                { key: 'pmhx', label: 'Medical History' },
                { key: 'pshx', label: 'Surgical History' },
                { key: 'psoc', label: 'Social History' },
                { key: 'pfhx', label: 'Family History' },
              ].map((tab) => (
                <CNavItem key={tab.key}>
                  <CNavLink
                    active={activeTab === tab.key}
                    onClick={() => setActiveTab(tab.key)}
                    style={{
                      cursor: 'pointer',
                      borderRadius: '6px',
                      margin: '0 5px',
                     
                   
                      border: activeTab === tab.key ? 'none' : '1px solid #444',
                      backgroundColor: activeTab === tab.key ? '#a9a9a9ff' : 'transparent',
                      color: activeTab === tab.key ? '#fff' : '#aaa',
                      fontWeight: activeTab === tab.key ? '300' : '200',
                      transition: 'all 0.2s ease-in-out',
                    }}
                  >
                    {tab.label}
                  </CNavLink>
                </CNavItem>
              ))}
            </CNav> */}
          <div className="d-flex mb-3 " style={{ borderBottom: 'none' }}>
            {[
              { key: 'pmhx', label: 'Medical History' },
              { key: 'pshx', label: 'Surgical History' },
              { key: 'sh', label: 'Social History' },
              { key: 'fh', label: 'Family History' },
            ].map((tab) => (
              <div
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                style={{
                  width: '30%',
                  cursor: 'pointer',
                  borderRadius: '6px',
                  border: activeTab === tab.key ? 'none' : '0.6px solid white',
                  backgroundColor: activeTab === tab.key ? '#989898' : 'transparent',
                  color: 'white',
                  fontWeight: activeTab === tab.key ? '300' : '200',
                  padding: '8px 16px',
                  transition: 'all 0.2s ease-in-out',
                  textAlign: 'center',
                  minWidth: '120px',
                }}
              >
                {tab.label}
              </div>
            ))}
          </div>

          {/* Tab Content */}
          <CTabContent>
            {['pmhx', 'pshx', 'sh', 'fh'].map((type) => (
              <CTabPane key={type} visible={activeTab === type}>
                <Graytextarea
                  type="text"
                  placeholder="Enter history here..."
                  value={textInput[type]}
                  rows={6}
                  onChange={(e) => handleInputChange(e, type)}
                  style={{
                    backgroundColor: '#191919',
                    color: 'white',
                    border: '1px solid #989898',
                    borderRadius: '6px',
                    width: '100%',
                    padding: '10px',
                    height: '200px',
                  }}
                />
              </CTabPane>
            ))}
          </CTabContent>
        </CModalBody>

        {/* Footer */}
        <CModalFooter
          style={{
            backgroundColor: '#282828',

            display: 'flex',
            justifyContent: 'center',
            gap: '15px',
            borderRadius: '0 0 10px 10px',
          }}
        >
          <CButton
            color="primary"
            style={{
              backgroundColor: '#4363F2',
              border: 'none',
              minWidth: '120px',
            }}
            onClick={() => addHistoryNote(activeTab)}
          >
            Save
          </CButton>
          <CButton
            style={{
              backgroundColor: '#444',
              color: 'white',
              border: 'none',
              minWidth: '120px',
            }}
            onClick={() => setAddHistoryToggle(false)}
          >
            Clear
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ProviderHistoryAddModalTest
